import type { ToothBasisSeriesRequest } from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import type { ToothSliceGeometry, ToothSliceOptionsBySeries } from '../config';

import { toEngineSliceOptions } from './toEngineSliceOptions';

export const makeToothBasisSeriesRequest = ({
  input,
  sliceOptions,
  spacingOutMm,
}: {
  input: ToothSliceGeometry;
  sliceOptions?: ToothSliceOptionsBySeries;
  spacingOutMm?: number;
}): ToothBasisSeriesRequest => ({
  anatomicalBasis: {
    MesioDistal: input.anatomicalBasis.mesioDistal,
    VestibuloOral: input.anatomicalBasis.vestibuloOral,
    Axial: input.anatomicalBasis.crownRoot,
  },
  searchBox: input.roi.innerBox ?? input.roi.outerBox,
  iso: input.numeration.iso,
  origin: input.origin,
  sliceOptions: sliceOptions && toEngineSliceOptions(sliceOptions),
  spacingOutMm,
  volumeFileID: input.volumeFileID,
  window: { wc: input.roi.windowLevel, ww: input.roi.windowWidth },
});
